import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Seo from "../component/common/Seo.jsx";
import { LOGO_SRC } from "../helpers/brand";

const Landing = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/home");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex flex-col items-center bg-bg-primary mt-40">
      <Seo
        title="Korehalal Trip | Korea Muslim DMC & Halal Travel"
        description="Korehalal Trip connects Muslim travelers with halal tours in Korea, the Korea Halal Map, halal restaurant delivery, prayer times, and more."
        path="/home"
      />
      <img src={LOGO_SRC} alt="Korehalal Logo" className="h-60 w-auto" />
      <h1 className="text-heading-lg text-text-primary my-6">Korehalal Trip</h1>
    </div>
  );
};

export default Landing;